import { gql } from '@apollo/client';
const GET_AUDIENCES = gql`
query GET_AUDIENCES {
    audiences{
      id
      name
    }
  }`
const GET_CATEGORIES = gql`
query GET_CATEGORIES {
  categories{
    id
    name
  }
}
`

const GET_MEDIA_TYPES = gql`
query GET_MEDIATYPES {
  media_types{
    id
    name
  }
}
`

const SUBS_GET_ARTICLES = gql`
subscription ($userEmail: String) {
  articles(where: {
    categories: {
      category: {
        user_preferences: {
          user_email: {_eq: $userEmail}
        }
      }
    }, 
    _not: {
      user_actions: {}
    }
  }, 
    limit: 5, order_by: {created_at: desc}) {
    id
    title
    website_link
  }
}
`

const MUTATION_USERS_ACTION =gql`mutation($userEmail: String!,
  $idArticle:Int!,
  $isRemoved:Boolean!,
  $isRead:Boolean! = true
  ) {
insert_user_notifications_actions_one(
  object:{article_id:$idArticle,
    user_email:$userEmail,
    removed:$isRemoved
    read:$isRead
  })
{
  id,
  article_id
}

}`

export default { GET_AUDIENCES, GET_CATEGORIES, GET_MEDIA_TYPES, SUBS_GET_ARTICLES,MUTATION_USERS_ACTION}
